export default class MouseStates {

  constructor() {
    this.onDotHover = false;
    this.currentTitle = '';
    this.element = {};
    this.detailOpen = false;
    this.showArticle = false;
    this.hoverPlane = false;
  }

  triggerOnAnimation(position) {
    this.onDotHover = true;
  }

  triggerOffAnimation(position) {
    this.onDotHover = false;
  }

  enabledDetailPage() {
    this.detailOpen = true;
  }
  
  disabledDetailPage() {
    this.detailOpen = false;
  }

  handleMouseIntersectPlane(bool) {
    this.hoverPlane = bool;
  }

  getDetailPage() {
    return this.detailOpen;
  }

  setCurrentDotTitle(title: '', el) {
    this.currentTitle = title;
    this.element = el;
  }

  setShowArticle(bool) {
    this.showArticle = bool;
  }

  getResultMatch(currentTitle) {
    return String(currentTitle) === this.currentTitle;
  }

  getHoverState() {
    return this.onDotHover;
  }

  getCurrentDotTitle() {
    return this.currentTitle;
  }
}


// WEBPACK FOOTER //
// ./src/utils/MouseStates.js